import PassengerCategory from '../modules/PassengerCategories/Model';
import { Tax } from '../modules/Taxes/Model';
export class Price {
    constructor(values) {
        // Object.assign(this, values)
        this.id = values.id;
        this.printPrice = values.printPrice;
        this.price = values.price;
        this.priceNet = values.priceNet;
        if (values.passengerCategory)
            this.passengerCategory = new PassengerCategory(values.passengerCategory);
        if (values.tax)
            this.tax = new Tax(values.tax);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/Models/Price.ts
// module id = 364
// module chunks = 0